export default __webpack_public_path__ + "media/images/metal_detect/foxes_detect_3-5cf057c16ef68acb8f227685ef2ac4f6.svg";